import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

export const getDaybook = async (filter = {}) => {
  try {
    console.log("🔍 API Call - Sending filter:", filter);
    const response = await axios.post(`${BASE_URL}/api/Daybook/get`, filter, {
      headers: getAuthHeader(),
    });
    console.log("📊 API Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ Error fetching daybook:", error);
    throw error;
  }
};

export const saveDaybook = async (daybook) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/Daybook/save`, daybook, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error saving daybook:", error);
    throw error;
  }
};

export const exportDaybookToExcel = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/Daybook/export-excel`, filter, {
      headers: getAuthHeader(),
      responseType: 'blob'
    });
    
    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `DaybookReport_${new Date().toISOString().slice(0,19).replace(/[-:]/g, '').replace('T', '_')}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    
    return true;
  } catch (error) {
    console.error("Error exporting daybook:", error);
    throw error;
  }
}; 